export const FETCH_MY_REFERRALS = 'referral/FETCH_MY_REFERRALS';
export const SET_REFERRALS = 'referral/SET_REFERRALS';
export const SET_REFERRALS_LOADING = 'referral/SET_REFERRALS_LOADING';
export const SET_REFERRALS_ERROR = 'referral/SET_REFERRALS_ERROR';

export const SEND_REFERRAL = 'referral/SEND_REFERRAL';
export const SET_SENDING_INVITATION = 'referral/SET_SENDING_INVITATION';
export const SET_INVITATION_MESSAGE = 'referral/SET_INVITATION_MESSAGE';
export const CLEAR_INVITATION_MESSAGE = 'referral/CLEAR_INVITATION_MESSAGE';
